/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateOrganizationRequest } from '../../models/create-organization-request';
import { OrganizationDto } from '../../models/organization-dto';

export interface OrganizationsPost$Json$Params {
      body?: CreateOrganizationRequest
}

export function organizationsPost$Json(http: HttpClient, rootUrl: string, params?: OrganizationsPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<OrganizationDto>> {
  const rb = new RequestBuilder(rootUrl, organizationsPost$Json.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OrganizationDto>;
    })
  );
}

organizationsPost$Json.PATH = '/organizations';
